import React from 'react'
import "./Product_ifile11.css"

function Product_ifile11() {
  return (
    <>
    <div>
        <div className="ifile-hero">
        {/* <img src="product-img/product4.jpg" alt="toll plaza" /> */}
        <video  className="ifile-video" autoPlay loop muted playsInline>
          <source src="ifile-product-img/heroifile_video.mp4" type="video/mp4"/>
        </video>
        <div className="ifile-overlay">
          <h1 data-aos="fade-up" className='fw-bold text-center transforming'>Digital Files, Applications & Ticketing in One Platform<br></br>
          <span className='ai-color'>One Connected Record. One Clear Workflow.</span> </h1>
          <p className='gradient-col'>
Centralized Control | AI Automation | Complete Transparency | Enterprise Security</p>
        </div>
      </div>
    </div>
    
    </>
  )
}

export default Product_ifile11
